import { render, staticRenderFns } from "./trends.vue?vue&type=template&id=468ee532&scoped=true&"
import script from "./trends.vue?vue&type=script&lang=js&"
export * from "./trends.vue?vue&type=script&lang=js&"
import style0 from "./trends.vue?vue&type=style&index=0&id=468ee532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ee532",
  null
  
)

export default component.exports